import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Hand16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M6.5 0.75C5.25736 0.75 4.25 1.75736 4.25 3V8.75H3.5C2.25736 8.75 1.25 9.75736 1.25 11V15H2.75L2.75 11C2.75 10.5858 3.08579 10.25 3.5 10.25H4.25V12.5H5.75V3C5.75 2.58579 6.08579 2.25 6.5 2.25C6.91422 2.25 7.25 2.58579 7.25 3L7.25 10.5H8.75V8.25H10.25V10.5H11.75V8.25H12.5C12.9142 8.25 13.25 8.58579 13.25 9V15H14.75V9C14.75 7.75736 13.7426 6.75 12.5 6.75H8.75V3C8.75 1.75736 7.74264 0.75 6.5 0.75Z'
      fill='currentColor'
    />
  </Svg>
);

Hand16.displayName = 'Hand16';
export default Hand16;
